// Occupation X/N des compartiments le long d'une séquence : par jeton (C1, C2…), les commandes à bord.
// Un compartiment partagé reste occupé tant qu'une de ses commandes n'est pas livrée.
const ANY_ORDER = "*";

export function cloneCompartmentOccupancy(occupied) {
  return new Map([...occupied].map(([token, orderIds]) => [token, new Set(orderIds)]));
}

export function applyCompartmentOccupancyChange(occupied, { tokens = [], stopType = "", occupantOrderIdsByToken = null } = {}) {
  if (!(occupied instanceof Map)) return occupied;
  tokens.forEach((token) => {
    const orderIds = occupantOrderIdsByToken?.[token] || [];
    if (stopType === "loading") {
      const current = occupied.get(token) || new Set();
      (orderIds.length ? orderIds : [ANY_ORDER]).forEach((orderId) => current.add(orderId));
      occupied.set(token, current);
    } else if (stopType === "delivery") {
      const current = occupied.get(token);
      if (!current) return;
      if (!orderIds.length) {
        occupied.delete(token);
        return;
      }
      orderIds.forEach((orderId) => current.delete(orderId));
      current.delete(ANY_ORDER);
      if (!current.size) occupied.delete(token);
    }
  });
  return occupied;
}
